import * as React from 'react'

import { Button } from '@/ui/button'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import { FaIcon, faEnvelope, faPrint, faXmark } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  count: number
  pending?: boolean
  onGenerate: (issuerSignature: boolean, driverSignature: boolean) => void
  onClear: () => void
  onSendEmail?: (issuerSignature: boolean, driverSignature: boolean) => void
  generateLabel?: string
}

/**
 * Pasek akcji dla wielokrotnego wyboru raportow - pojawia sie po zaznaczeniu
 * przynajmniej jednego raportu na liscie.
 */
export const BatchGenerateBar: React.FC<Props> = ({
  count,
  pending,
  onGenerate,
  onClear,
  onSendEmail,
  generateLabel,
}) => {
  const { t } = useLocalize()
  const [issuerSignature, setIssuerSignature] = React.useState(true)
  const [driverSignature, setDriverSignature] = React.useState(true)

  if (count === 0) return null

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-border-t tw-border-secondary tw-bg-white tw-px-4 tw-py-3 tw-shadow-[0_-2px_6px_rgba(0,0,0,0.06)]">
      <div className="tw-flex tw-items-center tw-gap-3">
        <FaIcon icon={faPrint} className="tw-h-4 tw-w-4 tw-text-content-base" />
        <span className="tw-text-sm tw-font-medium tw-text-content-base">
          {t('printout.selected-reports-count').replace('{0}', String(count))}
        </span>
        <button
          type="button"
          onClick={onClear}
          className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-content-base/70 hover:tw-text-primary"
        >
          <FaIcon icon={faXmark} className="tw-h-3 tw-w-3" />
          {t('printout.clear-selection')}
        </button>
      </div>

      <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        <CheckboxWithLabelField
          value={issuerSignature}
          onChange={setIssuerSignature}
          label={t('printout.issuer-signature')}
          disabled={pending}
          background={false}
          noPadding
        />
        <CheckboxWithLabelField
          value={driverSignature}
          onChange={setDriverSignature}
          label={t('printout.driver-signature')}
          disabled={pending}
          background={false}
          noPadding
        />
        {onSendEmail && (
          <Button
            variant="primary"
            size="sm"
            onClick={() => onSendEmail(issuerSignature, driverSignature)}
            disabled={pending}
            className="tw-h-[38px] tw-rounded-lg tw-px-4 tw-text-sm tw-font-medium"
          >
            <FaIcon icon={faEnvelope} className="tw-mr-2 tw-h-4 tw-w-4" />
            {t('printout.send-selected')}
          </Button>
        )}
        <Button
          variant="primary"
          size="sm"
          onClick={() => onGenerate(issuerSignature, driverSignature)}
          disabled={pending}
          className="tw-h-[38px] tw-rounded-lg tw-px-4 tw-text-sm tw-font-medium"
        >
          {generateLabel ?? t('printout.generate-selected')}
        </Button>
      </div>
    </div>
  )
}

export default BatchGenerateBar
